<template>
  <div class="richtext-container">
    <div class="richtext-wrapper" :style="{'max-height': overflowHeight && !isExpand ? overflowHeight + 'px': 'none'}">
      <div class="richtext-content" ref="richtext"  v-html="richtext"></div>
    </div>
    <div class="toggle-wrapper" v-if="overflowHeight">
      <span @click="toggle" v-if="!isExpand && height > overflowHeight">展开<i class="iconfont icon-down1"></i></span>
      <span @click="toggle" v-if="isExpand && height > overflowHeight">收起<i class="iconfont icon-up"></i></span>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant'
export default {
  name: 'RichtextComponent',
  props: {
    content: String,
    overflowHeight: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      height: 0,
      isExpand: false
    }
  },
  computed: {
    richtext () {
      if (this.content === undefined || this.content === null) {
        return ''
      }
      return this.content
    }
  },
  mounted () {
    var self = this
    this.$nextTick(() => {
      this.height = this.$refs.richtext.clientHeight
      console.log(this.height)
    })
    // console.log('richtext--',this.$refs.richtext.getElementsByTagName('img'))
    // this.$refs.richtext.getElementsByTagName('img').forEach(item => {
    //   item.addEventListener('click', (event) => {
    //     ImagePreview({
    //       images: [item.src],
    //       showIndex: false,
    //       onClose () {
    //         self.$emit('onClose')
    //       }
    //     })
    //     this.$emit('onOpen')
    //     event.preventDefault()
    //     // event.stopPropagation()
    //   })
    // })
  },
  methods: {
    // initMathJax () {
    //   this.$nextTick(() => {
    //     try {
    //       MathJax.Hub.Queue(["Typeset", MathJax.Hub, ""]);
    //       MathJax.Hub.Config({messageStyle: 'none',tex2jax: {preview: 'none'}});
    //       console.log('mathjax')
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   })
    // }
    toggle () {
      this.isExpand = !this.isExpand
    }
  },
  watch: {
    content: {
      handler () {
        // this.initMathJax()
        this.$nextTick(() => {
          this.height = this.$refs.richtext.clientHeight
          console.log(this.height)
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.richtext-wrapper{
  overflow: hidden;
}
.richtext-content{
  line-height: 20px;
  font-size: 14px;
  word-break: break-word;
  overflow: hidden;
  ::v-deep{
    img{
      max-width: 100%;
    }
    p{
      margin: 0 0 0 0;
    }
    svg{
      max-width: 100%;
    }
    table{
      max-width: 100%;
      width: 100% !important;
    }
  }
}
.toggle-wrapper{
  text-align: center;
  margin-top: 4px;
  span{
    cursor: pointer;
    i{
      margin-left: 6px;
      font-size: 12px;
    }
    &:hover{
      color: $--color-primary;
    }
  }
}
</style>